import React, { Component } from 'react'
import { connect } from 'react-redux'
import { deselectNippo, loadNippo, likeNippo } from '../actions'
import ReactMarkdown from 'react-markdown'
import breaks from 'remark-breaks'

class NippoModal extends Component {
  componentWillMount() {
    const { loadNippo, selectedNippo } = this.props
    loadNippo(selectedNippo)
  }

  render() {
    const { user, slackName, nippoData, replyList, users, deselectNippo, likeNippo } = this.props

    const nippoComponent = nippoData !== null
      ? (
        <article className="media nippo-main">
          <div className="media-left">
            <figure className="image is-64x64">
              <img src={users[nippoData.uid].images.x192} alt={nippoData.uid}/>
            </figure>
          </div>
          <div className="media-content">
            <div className="content">
              <strong>{users[nippoData.uid].displayName}</strong> <small>@{users[nippoData.uid].slackName}</small> <small>{nippoData.createdAt}</small>
              <br />
              <div>
                <ReactMarkdown
                  source={nippoData.text}
                  plugins={[breaks]}
                />
              </div>
            </div>
            <nav className="level is-mobile">
              <div className="level-left">
                <a className="level-item has-text-grey-light" aria-label="reply">
                  <span className="icon is-small">
                    <i className="fas fa-reply" aria-hidden="true"></i>
                  </span>
                  <p>
                    {nippoData.repliesCount}
                  </p>
                </a>
                <a className={nippoData.likes.includes(user.uid) ? "level-item has-text-danger" : "level-item has-text-grey-light"}
                  aria-label="like"
                  onClick={e => {e.stopPropagation();likeNippo(nippoData.postId, user.uid)}}
                >
                  <span className="icon is-small">
                    <i className="fas fa-heart" aria-hidden="true"></i>
                  </span>
                  <p>
                    {nippoData.likesCount}
                  </p>
                </a>
              </div>
            </nav>
          </div>
        </article>)
      : (<div>Loading...</div>)

    return (
      <div className={nippoData === null ? 'modal' : 'modal is-active'}>
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title"></p>
            <button className="delete" aria-label="close" onClick={deselectNippo}></button>
          </header>
          <section className="modal-card-body">
            { nippoComponent }
            {Object.keys(replyList).map(replyId =>
              <article className="media" key={replyId}>
                <figure className="media-left">
                  <figure className="image is-64x64">
                    <img src={users[replyList[replyId].uid].images.x192} alt={replyList[replyId].uid}/>
                  </figure>
                </figure>
                <div className="media-content">
                  <div className="content">
                    <p>
                      <strong>{users[replyList[replyId].uid].displayName}</strong> <small>@{users[replyList[replyId].uid].slackName}</small> <small>{replyList[replyId].createdAt}</small>
                      <br />
                      { replyList[replyId].text }
                      <br />
                    </p>
                  </div>
                  <nav className="level is-mobile">
                    <div className="level-left">
                      <a className="level-item" aria-label="like" onClick={e => likeNippo('id')}>
                        <span className="icon is-small">
                          <i className="fas fa-heart" aria-hidden="true"></i>
                        </span>
                        <p>
                          { replyList[replyId].likes }
                        </p>
                      </a>
                    </div>
                  </nav>
                </div>
              </article>
            )}
            <article className="media">
              <figure className="media-left">
                <p className="image is-64x64">
                  <img src={user.images.x192} alt={slackName} />
                </p>
              </figure>
              <div className="media-content">
                <div className="field">
                  <p className="control">
                    <textarea className="textarea" placeholder="Add a comment..." disabled="disabled"></textarea>
                  </p>
                </div>
              </div>
              {nippoData !== null &&
                <a className="button is-fullwidth comment-submit" href={'https://tabilabo.slack.com/archives/C04SE4M3X/p' + nippoData.postId.replace('.', '')}>
                  コメントする
                </a>}
            </article>
          </section>
          <footer className="modal-card-foot">
            <button className="button" onClick={deselectNippo}>Close</button>
          </footer>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    user: state.user,
    slackName: state.user.slackName,
    selectedNippo: state.nippo.selectedNippo,
    nippoData: state.nippo.nippoData,
    replyList: state.nippo.replyList,
    users: state.users
  }),
  { deselectNippo, likeNippo, loadNippo }
)(NippoModal)



// WEBPACK FOOTER //
// ./src/components/NippoModal.js